import { adminClient as apolloClient } from '@/store/apollo';

import CreateArticleStockReport from '@/extensions/shop/pointOfSale/store/graphql/mutations/CreateArticleStockReport.gql';

export default {
    createArticleStockReport: (stockId) => {
        if (stockId === undefined) {
            throw new Error('required argument is missing')
        }

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: CreateArticleStockReport,
                variables: {
                    stockId
                }
            })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch(err => reject(err))
        })
    }
};
